import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'

import { toggleMediaDatabase } from 'actions/MediaDatabaseToggle'
import { GetWithNonce } from 'utils/axios-nonce'
import { Get as PublicGet } from 'utils/axios-template'
import { Get, Post, Put, Delete } from 'utils/axios-token'
import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      showCreateProgramme: false,
      loading: false,
      pages: [],
      anchorLinks: [],
      programmes: [],
      searchParams: [
        {
          label: Lang['FAIRS'][this.props.data.languageReducer.userSettings.admin_panel_language],
          value: 'fair_id',
          col: 6,
          isNumeric: true,
          param: '',
          type: 'select',
          options: []
        },
        {
          label: `${Lang['SPEAKER'][this.props.data.languageReducer.userSettings.admin_panel_language]} - ${Lang['FIRST_NAME'][this.props.data.languageReducer.userSettings.admin_panel_language]}`,
          value: 'first_name',
          col: 6,
          param: ''
        },
        {
          label: `${Lang['SPEAKER'][this.props.data.languageReducer.userSettings.admin_panel_language]} - ${Lang['LAST_NAME'][this.props.data.languageReducer.userSettings.admin_panel_language]}`,
          value: 'last_name',
          col: 6,
          param: ''
        },
        {
          label: Lang['STAGES'][this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 6,
          value: 'stage_id',
          type: 'select',
          isNumeric: true,
          param: '',
          options: []
        },
        {
          label: Lang['TITLE'][this.props.data.languageReducer.userSettings.admin_panel_language],
          col: 6,
          value: 'short_description',
          param: ''
        },
      ],
      programmesMeta: {
        current_page: 1,
        per_page: 10,
        last_page: 1,
        total_results: 1
      },
      defaultQuery: {},
      selectedProgramme: null,
      showEditModal: false,
      subscribedPackage: false,
      showDeleteConfirmation: false,
      showCancelConfirmation: false,
      showViewProgrammeModal: false,
      query: {},

      fairs: [],
      stages: [],
      users: []
    }

    onChangeProgrammeHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getProgramme = (query) => {
      this.setState({ query })

      GetWithNonce(
        `/api/v1/fex/fairs_programmes?query=${convertSearchObjectToBase64(query)}`,
        this.getProgrammeSuccess,
        this.getProgrammeError,
        this.load,
        this.props.data.languageReducer.userSettings.admin_panel_language
      )
    }
    getProgrammeSuccess = payload => this.setState({
      programmes: payload.data,
      programmesMeta: payload.meta
    })
    getProgrammeError = error => this.requestError(error.toString())

    getFairs = () => {
      Get(
        `/api/v1/fex/fairs?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: {
            "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id,
            "is_active": true,
          }
        })}`,
        this.getFairsSuccess,
        this.getFairsError,
        this.load
      )
    }
    getFairsSuccess = payload => this.setState({
      fairs: _.map(payload.data, child => ({
        ...child,
        label: child.title,
        value: child.short_title,
        name: child.short_title,
        id: child.id
      }))
    })
    getFairsError = error => this.requestError(error.toString())

    createProgramme = dataToSubmit => {
      Post(
        `/api/v1/fex/fairs_programmes`,
        dataToSubmit,
        this.createProgrammeSuccess,
        this.createProgrammeError,
        this.load
      )
    }
    createProgrammeSuccess = () => {
      this.requestSuccess(Lang['RECORD_CREATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showCreateProgramme: false,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id, }
        }
      }, () => this.getProgramme(this.state.query))
    }
    createProgrammeError = error => {
      if (error.name) {
        this.requestError(error.name)
      } else {
        this.requestError(error)
      }
    }

    getSelectedProgramme = id => {
      Get(
        `/api/v1/fex/fairs_programmes/${id}`,
        this.getSelectedProgrammeSuccess,
        this.getSelectedProgrammeError,
        this.load
      )
    }
    getSelectedProgrammeSuccess = payload => this.setState({ selectedProgramme: payload, showEditModal: true })
    getSelectedProgrammeError = error => this.requestError(error)

    updateProgramme = (dataToSubmit) => {
      Put(
        `/api/v1/fex/fairs_programmes/${dataToSubmit.id}`,
        dataToSubmit,
        this.updateProgrammeSuccess,
        this.updateProgrammeError,
        this.load
      )
    }
    updateProgrammeSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        showEditModal: false,
        showCancelConfirmation: false,
        selectedProgramme: null,
        query: {
          page: 1,
          is_paginated: true,
          filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id, }
        }
      }, () => this.getProgramme(this.state.query))
    }
    updateProgrammeError = error => this.requestError(error)

    getStages = () => {
      GetWithNonce(
        `/api/v1/fex/stages?query=${convertSearchObjectToBase64({
          page: 1,
          is_paginated: false,
          filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id, }
        })}`,
        this.getStagesSuccess,
        this.getStagesError,
        this.load
      )
    }
    getStagesSuccess = payload => {
      let temp = _.filter(payload.data, child => child.status !== 'INACTIVE')

      this.setState({
        stages: _.map(temp, child => ({
          ...child,
          name: child.title[this.props.data.languageReducer.userSettings.admin_panel_language],
          label: child.title[this.props.data.languageReducer.userSettings.admin_panel_language],
          value: child.id,
          id: child.id
        }))
      })
    }
    getStagesError = error => this.requestError(error.toString())

    getUsers = () => {
      let temp = {
        page: 1,
        is_paginated: false,
        filter: { "client_id": this.props.data.selectCenterReducer.selectedCenter.center.client_id },
      }

      Get(
        `/api/v1/fex/portal_users?query=${convertSearchObjectToBase64(temp)}`,
        this.getUsersSuccess,
        this.getUsersError,
        this.load
      )
    }
    getUsersSuccess = payload => {
      let temp = _.filter(payload.data, child => child.status !== 'INACTIVE')
      temp = _.filter(temp, child => {
        return child.role === 'SPEAKER' || child.is_also_speaker
      })

      this.setState({
        users: _.map(temp, child => ({
          ...child,
          label: `${child.company_name}`,
          name: `${child.company_name}`,
          value: child.id,
          id: child.id
        }))
      })
    }
    getUsersError = error => this.requestError(error.toString())

    deleteProgramme = id => Delete(
      `/api/v1/fex/fairs_programmes/${id}`,
      this.deleteProgrammeSuccess,
      this.deleteProgrammeError,
      this.load
    )
    deleteProgrammeSuccess = () => {
      this.setState({
        showDeleteConfirmation: false,
        selectedProgramme: null
      })
      this.getProgramme(this.state.query)
      this.requestSuccess(Lang['RECORD_DELETE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }
    deleteProgrammeError = error => this.requestError(error.toString())

    getAnchorLinks = (site_id) => PublicGet(
      `/api/v1/sites/${site_id}/anchor_links`,
      this.getAnchorLinksSuccess,
      this.getAnchorLinksError,
      this.load
    )
    getAnchorLinksSuccess = payload => this.setState({ anchorLinks: payload.data })
    getAnchorLinksError = error => this.requestError(error)

    getPages = (site_id) => PublicGet(
      `/api/v1/sites/${site_id}/pages`,
      this.getPagesSuccess,
      this.getPagesError,
      this.load
    )
    getPagesSuccess = payload => this.setState({ pages: payload.data })
    getPagesError = error => this.requestError(error)

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadProgrammeHOC={this.state.loading}
          getAnchorLinks={this.getAnchorLinks}
          getPages={this.getPages}
          getUsers={this.getUsers}
          getFairs={this.getFairs}
          getStages={this.getStages}
          getProgramme={this.getProgramme}
          createProgramme={this.createProgramme}
          getSelectedProgramme={this.getSelectedProgramme}
          updateProgramme={this.updateProgramme}
          onChangeProgrammeHOC={this.onChangeProgrammeHOC}
          deleteProgramme={this.deleteProgramme}
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps, {
    toggleMediaDatabase
  })(WithHOC)
}

export default HOC
